import { createApiClient } from '../../../api/apiClient';
import { SYSTEM_REST_API_BASE_URL } from '../../../config';
import { notify } from '../../../utils/notify';
const REST_API_BASE_URL = SYSTEM_REST_API_BASE_URL;

// Dedicated instance so the error-handling interceptor below doesn't affect
// other service calls that use the shared apiClient singleton.
const axiosInstance = createApiClient();

axiosInstance.interceptors.response.use(
  (response) => {
    console.log('Request completed');
    return response;
  },
  (error) => {
    console.log('Request failed');

    if (error.response) {
      const status = error.response.status;
      console.log('Status:', status);
      console.log('Data:', error.response.data);
      console.log('Data error:', error.response.data?.message);

      switch (status) {
        case 400:
          notify('Invalid request. Please check your input.');
          break;
        case 401:
          notify('You are not authorized. Please log in.');
          break;
        case 403:
          notify('Access denied. You do not have permission.');
          break;
        case 404:
          notify('Resource not found. Please try again.');
          break;
        case 409:
          notify('Conflict detected. Please check your input.');
          break;
        case 422:
          notify('Validation failed. Please correct the highlighted errors.');
          break;
        case 429:
          notify(
            'Too many requests. Please wait and try again later.',
            'warning',
          );
          break;
        case 500:
          notify('Something went wrong on our end. Please try again later.');
          break;
        case 503:
          notify('Service temporarily unavailable. Please try again later.');
          break;
        default:
          notify(
            error.response.data?.message
              ? `Error: ${error.response.data.message}`
              : 'An unexpected error occurred. Please try again.',
          );
      }
    } else {
      console.log('Error:', error.message);
      notify('Network error. Please check your connection.');
    }

    return Promise.reject(error);
  },
);

export const getCartItemsCount = () =>
  axiosInstance.get(`${REST_API_BASE_URL}/account/cart/items/total-quantity`);

export const getCartItems = () =>
  axiosInstance.get(`${REST_API_BASE_URL}/account/cart-items`);

// export const saveCart = (accountid) => axiosInstance.post(`${REST_API_BASE_URL}/account/${accountid}/cart`);
export const saveCart = () => axiosInstance.post(`${REST_API_BASE_URL}/cart`);

export const addProductToCart = (productid, quantity) =>
  axiosInstance.post(
    `${REST_API_BASE_URL}/account/cart/product/${productid}/?quantity=${quantity}`,
  );

export const deleteProductFromCart = (productid) =>
  axiosInstance.delete(
    `${REST_API_BASE_URL}/account/cart/product/${productid}`,
  );

export const updateCartQuantity = (productid, quantity) =>
  axiosInstance.post(
    `${REST_API_BASE_URL}/update-cart-quantity/${productid}/?quantity=${quantity}`,
  );

export const saveDiscountCode = (discountCode) =>
  axiosInstance.post(`${REST_API_BASE_URL}/discount-codes`, discountCode);

export const applyDiscountCode = (discountCode) =>
  axiosInstance.post(
    `${REST_API_BASE_URL}/account/cart/apply-discount-code?discountCode=${discountCode}`,
  );

export const removeDiscountCode = () =>
  axiosInstance.post(`${REST_API_BASE_URL}/account/cart/remove-discount-code`);

export const getCartOrderSummary = () =>
  axiosInstance.get(`${REST_API_BASE_URL}/account/cart-order-summary`);

export const createCheckoutOrder = (accountid) =>
  axiosInstance.post(`${REST_API_BASE_URL}/account/${accountid}/checkout`);

export const saveAccountAddress = (accountid) =>
  axiosInstance.post(
    `${REST_API_BASE_URL}/account/${accountid}/shipping-address`,
  );

export const getAccountAddress = (accountid) =>
  axiosInstance.get(
    `${REST_API_BASE_URL}/account/${accountid}/shipping-address`,
  );

export const saveBillingAddress = (accountid) =>
  axiosInstance.post(
    `${REST_API_BASE_URL}/account/${accountid}/billing-address`,
  );

export const getBillingAddress = (accountid) =>
  axiosInstance.get(
    `${REST_API_BASE_URL}/account/${accountid}/billing-address`,
  );

export const getOrderSummary = (accountid, cartid) =>
  axiosInstance.get(
    `${REST_API_BASE_URL}/account/${accountid}/cart/${cartid}/order/summary`,
  );

export default axiosInstance;
